module.exports = __webpack_public_path__ + "img/票.de17726c.svg";